import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import  Axios  from "../../utils/axios"

export const reqToFetchBlogs = createAsyncThunk("blogs/reqToFetchBlogs", async ({perPage, page},{rejectWithValue}) => {
    try{
      const response = await Axios.get(`/api/blogs`,{ params: {perPage,page} });
      return response.data;
    }catch(error){
      return rejectWithValue(error.response.data);
    }
});

export const reqToFetchBlogDetails = createAsyncThunk("blogs/reqToFetchBlogDetails", async ({id},{rejectWithValue}) => {
  try{
    const response = await Axios.get(`/api/blogs/${id}`);
    return response.data;
  }catch(error){
    return rejectWithValue(error.response.data);
  }
})


const blogSlice = createSlice({
    name:"blogs",
    initialState:{
        error:null,
        isLoading:false,
        blogs:[],
        blogDetails:{}
    },
    reducer:{},
    extraReducers:(builder)=>{
        builder
        .addCase(reqToFetchBlogs.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(reqToFetchBlogs.fulfilled, (state, action) => {
          state.isLoading = false;
          state.blogs = action.payload;
        })
        .addCase(reqToFetchBlogs.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload
        })
        // Blog Details
        .addCase(reqToFetchBlogDetails.fulfilled, (state,action) => {
          state.blogDetails = action.payload;
        })
    }
})

export default blogSlice.reducer;